module.exports = __webpack_public_path__ + "img/formsTrapezSOL.6d9025ac.svg";